import { NAVIGATION_RECEIVE } from '../constants';

const defaultState = {
    menu: [],
    contentLinks: window.__litium?.preloadState?.navigation?.contentLinks || [],
    featuredItems: window.__litium?.preloadState?.navigation?.featuredItems || null,
};

export const navigation = (state = defaultState, action) => {
    switch (action.type) {
        case NAVIGATION_RECEIVE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
